import { Link, useParams } from 'react-router-dom';
import { UnpopulatedEvent } from '../../../utils/types';
import UserAvatar from '../UserAvatar/UserAvatar';
import { eventTypeMap } from '../../../utils/consts';
import { Icon, TextField, Title } from '..';
import { useTranslation } from '../../../hooks/translations/TranslationProvider';
import { useAppSelector } from '../../../store/hooks';
import { renderEventTime } from '../../../utils/helpers';

import './eventRow.css';

interface EventRowProps {
    eventRecord: UnpopulatedEvent;
}

const EventRow: React.FC<EventRowProps> = ({ eventRecord }) => {
    const { lang } = useParams();
    const { t } = useTranslation();
    const locale = lang === 'pl' ? lang : 'en';
    const auth = useAppSelector(state => state.auth);
    const language = auth.authData?.language;

    const eventTime = renderEventTime(eventRecord.date, language);

    const eventPrice =
        (eventRecord.totalPrice / eventRecord.maxUsers) % 1 !== 0
            ? (eventRecord.totalPrice / eventRecord.maxUsers).toFixed(1)
            : eventRecord.totalPrice / eventRecord.maxUsers;

    const price =
        eventRecord.currency === 'PLN' ? `${eventPrice} zł` : eventPrice;

    const key = eventTypeMap[eventRecord.type].toLowerCase();

    return (
        <Link to={`/${locale}/events/${eventRecord.id}`}>
            <div className="event-row">
                <TextField size="xl" color="subtitle" weight="bold">
                    {eventTime}
                </TextField>
                <div className="event-row-record">
                    <div className="event-row-record-overview">
                        <div className="event-row-title">
                            <Title
                                text={`${t(`eventTypes.${key}`)} - ${
                                    eventRecord.place
                                }`}
                                size="m"
                            />
                        </div>
                        <div className="event-row-owner">
                            <UserAvatar
                                imageSrc={eventRecord.owner.avatarUrl}
                                size="xs"
                                averageRating={eventRecord.owner.averageRating}
                            />
                            <TextField size="s" color="subtitle">
                                {eventRecord.owner.username}
                            </TextField>
                        </div>
                    </div>
                    <div className="event-row-record-details">
                        <div>
                            <Icon name="bx-user-check" />
                            <TextField color="green" size="s" weight="bold">
                                {`${eventRecord.joinedUsers}/${eventRecord.maxUsers}`}
                            </TextField>
                        </div>
                        <div>
                            {(eventPrice as number) > 0 ? (
                                <>
                                    {eventRecord.currency === 'GBP' && (
                                        <Icon name="bx-pound" size="18px" />
                                    )}
                                    <TextField
                                        size="l"
                                        color="subtitle"
                                        weight="bold"
                                    >
                                        {price}
                                    </TextField>
                                </>
                            ) : (
                                <div className="pill pill-light-green">
                                    <TextField
                                        size="m"
                                        color="green"
                                        weight="bold"
                                    >
                                        {t('common.free')}
                                    </TextField>
                                </div>
                            )}
                        </div>
                    </div>
                    {/* <div className="event-row-actions">
                        <Link to={`/${locale}/events/${eventRecord.id}`}>
                            <Button
                                text={t('common.viewEvent')}
                                size="sm"
                                variant="green"
                            />
                        </Link>
                    </div> */}
                </div>
            </div>
        </Link>
    );
};

export default EventRow;
